var map = {
	"./localizations-en.json": 783,
	"./localizations-fi.json": 784
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 354;


//////////////////
// WEBPACK FOOTER
// ./public/json ^\.\/localizations\-.*\.json$
// module id = 354
// module chunks = 23